/** @jsx jsx */
import { jsx } from '@emotion/core'
import style from './orderDetailsStyle';
import React from 'react';

import { SiteLink } from '../../../components';

import { usePost } from '../../../components';
import { Button } from '../../../components';

import env from '../../../env';
import { useGet } from '../../../components';
import { Loading, ErrorPopup } from '../../../components';
import { useRouter } from '../../../components';

import utils from '../../../utils';


export function OrderDetails() {
  const get = useGet();
  const { query } = useRouter();
  const id = query.id || '';

  React.useEffect(() => {
    get.send(env.apiBase + '/api/orderAdmin/getPaidOrder/' + id);
    // eslint-disable-next-line
  }, []);

  if (get.loading()) {
    return <Loading />
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  const order = get.response.orderDetail;

  return <React.Fragment>
    <div>
      <SiteLink to="/admin/orders">&lt; Return to list</SiteLink>
    </div>
    <Details order={order} />
  </React.Fragment>

}

function Details({ order }) {
  
  console.log('order', order);
  
  function itemAmount(orderItem) {
    return (orderItem.unitPrice * 100) / 100;
  }
  // function itemTotalAmount(orderItem) {
  //   return (orderItem.quantity * (orderItem.unitPrice * 100 + orderItem.addedUnitPrice * 100 - orderItem.discountUnitPrice * 100)) / 100;
  // }

  return <div css={style.orderDetails}>

    <hr />
    <div className="row">
      <div className="col-md-12">
        <div><label css={style.fn}>Order Number:</label> <span css={style.fv}>{order.orderNo}</span> </div>
        <div><label css={style.fn}>Total Amount:</label> <span css={style.fv}><b>AU {utils.money.formatMoney(order.totalAmount)}</b></span> </div>
        <div><label css={style.fn}>Order Date:</label> <span css={style.fv}>{utils.date.formatYYYYMMDD(order.orderDate)}</span> </div>
      </div>
    </div>
    <hr />

    <h3>Items</h3>
    <div css={style.orderItems}>
      {order.orderItems.map((orderItem, i) => <div css={style.orderItem} className={`row ${orderItem.orderItemType !== 0 ? "hide" : ""}`} key={orderItem.orderItemId}>
        <div className="col-6">
          <b dangerouslySetInnerHTML={{ __html: orderItem.itemName }}></b>
          <div dangerouslySetInnerHTML={{ __html: orderItem.itemDescHtml }}></div>
        </div>
        <div className="col-3">
          <div className="price">Unit Price: {utils.money.formatMoney(itemAmount(orderItem))}</div>
        </div>
        <div className="col-3">
          Qty: {orderItem.quantity}
        </div>
      </div>
      )}

      <div className="row">
        <div className="col-12">
          <div css={style.total} style={{color:'black', fontWeight:'400'}}>
            GST: AU {utils.money.formatMoney(order.taxAmount)}
          </div>
        </div>
      </div>

      <hr />

      <div className="row">
        <div className="col-12">
          <div css={style.total} style={{color:'black', fontWeight:'400'}}>
            Shipping: AU {utils.money.formatMoney(order.shippingAmount)}
          </div>
        </div>
      </div>

      <hr />

      <div className="row">
        <div className="col-12">
          <div css={style.total}>
            Total: AU {utils.money.formatMoney(order.totalAmount)}
            {/* <span className="total-price">Item Total: {utils.money.formatMoney(order.itemAmount)}
                <span> + Shipping Fee: {order.shippingAmount > 0 ? 'AU ' + utils.money.formatMoney(order.shippingAmount) : 'FREE'}</span>
                <span> + GST: {utils.money.formatMoney(order.taxAmount)}</span>
              </span>
              <div className="grand-total">Grand Total (including GST): AU {utils.money.formatMoney(order.totalAmount)}
              </div> */}
          </div>
        </div>
      </div>

    </div>
    <hr />
    
    <h3>
      Delivery Method
    </h3>
    <div>
              { order.shippingMethod }
    </div>
    
    <hr />

    <div className="row">
      <div className="col-md-6">
        <h3>Shipping Address</h3>
        {order.shippingAddress && <div>
          <Address addr={order.shippingAddress} />
        </div>}

      </div>
      <div className="col-md-6">
        <h3>Billing Address</h3>
        {order.useSameAddress ? <span>Use the same address</span> : null}
        {order.billingAddress && <div>
          <Address addr={order.billingAddress} />
        </div>}
      </div>
    </div>



    <hr />
    <Admin order={order} />

  </div>;
}

function Address({ addr }) {
  return <div>
    <div><label css={style.fn}>First Name:</label> <span css={style.fv}>{addr.firstName}</span> </div>
    <div><label css={style.fn}>Surame:</label> <span css={style.fv}>{addr.surname}</span> </div>
    <div>
      <label css={style.fn}>Address:</label>
      <span css={style.fv}>{addr.street1}</span>
      <span style={{marginLeft: '0.5rem'}}>{addr.street2}</span>
    </div>
    <div><label css={style.fn}>Suburb:</label> <span css={style.fv}>{addr.suburb}</span> </div>
    <div><label css={style.fn}>State:</label> <span css={style.fv}>{addr.state}</span> </div>
    <div><label css={style.fn}>Postcode:</label> <span css={style.fv}>{addr.postcode}</span> </div>
    <div><label css={style.fn}>Email Address:</label> <span css={style.fv}>{addr.email}</span> </div>
    <div><label css={style.fn}>Mobile:</label> <span css={style.fv}>{addr.mobile}</span> </div>
  </div>
}

function Admin({ order }) {

  return <div>
    <ResendAdmin order={order} />
    <hr />
    <ResendClient order={order} />
    <hr />
    <ResendVend order={order} />
  </div>
}

function ResendAdmin({ order }) {
  const [sendingStatus, setSendingStatus] = React.useState(null);
  const post = usePost();

  function resendAdmin(e) {
    if (!window.confirm('Resend to admin?')) return;
    post.send(env.apiBase + "/api/orderAdmin/resendAdminNotice", { orderId: order.orderId });
    setSendingStatus('pending')
  }

  if (post.done() && sendingStatus === 'pending') {
    setSendingStatus(null)
  }


  return <div style={{ marginTop: '1.5rem' }}>
    <Button onClick={resendAdmin} status={post.status}>Resend to Admin</Button>
    {post.done() && <span style={{ color: 'chocolate', marginLeft: '1rem' }}>Successfully Sent</span>}
  </div>
}

function ResendClient({ order }) {
  const emailAddress = order.shippingAddress ? order.shippingAddress.email : (
    order.billingAddress ? order.billingAddress.email : ''
  )
  const [sendingStatus, setSendingStatus] = React.useState(null);
  const [email, setEmail] = React.useState(emailAddress);

  const post = usePost();

  function resendAdmin(e) {
    if (!window.confirm('Resend to the client?')) return;
    post.send(env.apiBase + "/api/orderAdmin/resendReceipt", { orderId: order.orderId, email: email });
    setSendingStatus('pending')
  }

  if (post.done() && sendingStatus === 'pending') {
    setSendingStatus(null)
  }


  return <div style={{ marginTop: '1.5rem' }}>
    <div className="row">
      <div className="col-md-2">Client Email</div>
      <div className="col-md-4">
        <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)}></input>
      </div>
    </div>

    <Button onClick={resendAdmin} status={post.status}>Resend to Client</Button>
    {post.done() && <span style={{ color: 'chocolate', marginLeft: '1rem' }}>Successfully Sent</span>}
  </div>
}


function ResendVend({ order }) {
  const [sendingStatus, setSendingStatus] = React.useState(null);
  const post = usePost();

  function resendVend(e) {
    if (!window.confirm('Resend to Vend?')) return;
    post.send(env.apiBase + "/api/vendAdmin/resendVend", { orderId: order.orderId });
    setSendingStatus('pending')
  }

  if (post.done() && sendingStatus === 'pending') {
    setSendingStatus(null)
  }


  return <div style={{ marginTop: '1.5rem' }}>
    <Button onClick={resendVend} status={post.status}>Resend to Vend</Button>
    {post.done() && <span style={{ color: 'chocolate', marginLeft: '1rem' }}>Successfully Sent</span>}
  </div>
}